var STORAGE_KEY = 'user.sectorisation.regions';

/**
 * @class DepartementsService
 */
function DepartementsService($q, $indexedDB, localStorageService) {
    var self = this;
    self.selected = false;

    self.getSelectedList = function() {
        var depts = localStorageService.get(STORAGE_KEY);
        self.selected = depts ? JSON.parse(depts) : [];
        return self.selected;
    };

    self.toggle = function(code) {
        var index = self.selected.indexOf(code);
        if (index == -1) {
            self.selected.push(code);
        }
        else {
            self.selected.splice(index, 1);
        }
    };

    self.add = function(code) {
        var index = self.selected.indexOf(code);
        if (index == -1) {
            self.selected.push(code);
        }
    };

    self.remove = function(code) {
        var index = self.selected.indexOf(code);
        if (index > -1) {
            self.selected.splice(index, 1);
        }
    };

    self.save = function(depts) {
        self.selected = depts;
        localStorageService.set(STORAGE_KEY, angular.toJson(self.selected));
    };

    return self;
}
DepartementsService.$inject = ['$q', '$indexedDB', 'localStorageService'];

angular.module('app.prospection.search').factory('departementsService', DepartementsService);
